<div class="card card-custom">
  <div class="card-header d-flex align-items-center justify-content-between py-2">
    <div style="width: 200px" class="d-flex align-items-center justify-content-start">
      <img alt="" height="45" src="assets/media/svg/icons/Files/tif.png" />
    </div>
    <div class="d-flex align-items-center">
      <button
        matTooltip="First"
        class="btn btn-icon btn-sm btn-light mx-1"
        [disabled]="pageIndex === 0"
        (click)="changePage($event, 'FIRST')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-to-left.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <button
        matTooltip="Prev"
        class="btn btn-icon btn-sm btn-light mx-1"
        [disabled]="pageIndex === 0"
        (click)="changePage($event, 'PREV')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-left.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <div style="width: 60px" class="font-weight-bold text-center mx-1">
        {{ pageIndex + 1 }} OF {{ pages.length }}
      </div>
      <button
        matTooltip="Next"
        class="btn btn-icon btn-sm btn-light mx-1"
        [disabled]="pageIndex === pages.length - 1"
        (click)="changePage($event, 'NEXT')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-right.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
      <button
        matTooltip="Last"
        class="btn btn-icon btn-sm btn-light mx-1"
        [disabled]="pageIndex === pages.length - 1"
        (click)="changePage($event, 'LAST')"
      >
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Arrow-to-right.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
    </div>
    <div style="width: 200px" class="d-flex align-items-center justify-content-between">
      <div>
        <button
          matTooltip="Zoom Out"
          class="btn btn-icon btn-sm btn-light mx-1"
          (click)="zoom($event, 'OUT')"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/zoom-out.svg"
            class="svg-icon svg-icon-md svg-icon-info"
          ></span>
        </button>
        <button
          matTooltip="Zoom Fit"
          class="btn btn-icon btn-sm btn-light mx-1"
          (click)="zoom($event, 'FIT')"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/zoom-fit.svg"
            class="svg-icon svg-icon-md svg-icon-info"
          ></span>
        </button>
        <button
          matTooltip="Zoom In"
          class="btn btn-icon btn-sm btn-light mx-1"
          (click)="zoom($event, 'IN')"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/zoom-in.svg"
            class="svg-icon svg-icon-md svg-icon-info"
          ></span>
        </button>
      </div>
      <button matTooltip="Close" class="btn btn-icon btn-sm btn-light" (click)="close($event)">
        <span
          inlineSVG="assets/media/svg/icons/Navigation/Close.svg"
          class="svg-icon svg-icon-md svg-icon-info"
        ></span>
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="tif-viewer">
      <div *ngIf="loadingTif | async" class="d-flex flex-center w-100 h-100">
        <mat-spinner color="warn" strokeWidth="5"></mat-spinner>
      </div>
      <img
        *ngIf="!(loadingTif | async)"
        alt=""
        [style.width]="zoomScale * 100 + '%'"
        [src]="pages[pageIndex]"
      />
    </div>
  </div>
</div>
